module.exports = __webpack_public_path__ + "static/media/3.ea68de85.jpg";